import React, { useEffect } from "react";

const ThankYouPage = (props) => {
  const formName = props.match.params.formName;
  useEffect(() => {
    localStorage.removeItem("minutess");
    localStorage.removeItem("secondss");
    localStorage.removeItem("Name");
    localStorage.removeItem("Email");
    localStorage.removeItem("minutes");
    localStorage.removeItem("seconds");
  }, [formName]);
  return (
    <div className="container">
      <div className="row justify-content-center mt-5">
        <div className="col-md-6 col-lg-5">
          <div className="bg-white rounded shadow-sm p-4 text-center">
            <h2 className="mb-3 text-[#f5901f] text-[2rem]">Thank You!</h2>
            <p className="text-muted mb-0">
              Your response has been submitted successfully.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
